import React from "react";
import { CCard, CCardBody, CCardHeader } from "@coreui/react";

const ShippingPolicy = () => {
  return (
    <div className="privacy-page">
      <CCard className="privacy-card">
        <CCardHeader className="privacy-header">
          <h2>Shipping Policy</h2>
        </CCardHeader>

        <CCardBody className="privacy-body">
          <p>We currently don&rsquo;t ship orders.</p>
        </CCardBody>
      </CCard>
    </div>
  );
};

export default ShippingPolicy;
